module.exports = __webpack_public_path__ + "static/camp_success.a4bba74c.svg";